import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchFromAPI } from "../../../Services/apiService";

export default function TestError() {
  const navigate = useNavigate();

  useEffect(() => {
    fetchFromAPI("/wrong-url", "GET", null, navigate); // this should 500
  }, []);

  return (
    <div>
      <h2>Testing Error Redirection...</h2>
    </div>
  );
}
